import { render, staticRenderFns } from "./DesignerAssignment.vue?vue&type=template&id=07c046d8"
import script from "./DesignerAssignment.vue?vue&type=script&lang=ts"
export * from "./DesignerAssignment.vue?vue&type=script&lang=ts"
import style0 from "./DesignerAssignment.vue?vue&type=style&index=0&id=07c046d8&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports